/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ThumbDownIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Thumb Down',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect height="18" rx="1" ry="1" width="6" x="2" y="6" />
    <path
      d="M31.077 21.89H21.11a63.859 63.859 0 0 1 .89 9.19c0 1.661-1.032 2.92-2 2.92a1.839 1.839 0 0 1-2-2 11.326 11.326 0 0 0-2.516-6.258A46.35 46.35 0 0 0 10 20.958V6s2.809.033 14 0a3.946 3.946 0 0 1 3.677 2.424l5.128 10.788a1.862 1.862 0 0 1-1.728 2.678Z"
    />
  </svg>`;
};
